
import React,{useState} from 'react'
import { Row, Col, Tab, Nav } from 'react-bootstrap'
import '../../../sassFiles/sassPages/admindashboard/hr/hrStyle.scss'
import CanvasJSReact from '@canvasjs/react-charts';
import { hrDashboardHiringProcessApi } from '../../../utils/AdminDashApi/HRdashboardApi'
import PillSmall from '../../subComponents/CustomSubComponents/PillSmall'
import SingleApplicantBox from '../desktop/HRcomps/HRsubComps/SingleApplicantBox';
import "react-daterange-picker/dist/css/react-calendar.css"; 
import DateRangePicker from "react-daterange-picker";
import { applicantList } from '../../../utils/AdminDashApi/HRapplicantList';
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import { BsChevronDown } from 'react-icons/bs'
//var CanvasJSReact = require('@canvasjs/react-charts');
const moment = extendMoment(originalMoment);
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
const HRDashboardCompmb = () => {
    const today = moment();
    const [value, setValue] = useState(
      moment.range(today.clone().subtract(7, "days"), today.clone())
    );
    const [display, setDisplay] = useState(false);
  
    const onSelect = (newValue) => {
      setValue(newValue);
      setDisplay(!display)
    };
    const handleshowdatepicker =()=>{
        setDisplay(!display)
    }

    const [drpoftable,setdrpoftable] = useState(false)

    const [activeCell, setActiveCell] = useState(null);

   
    function updateStatus(index, newStatus) {
        hrDashboardHiringProcessApi.data[index].status = newStatus;
      }
    const handleImageClick = (e,index,clickedname) => {
      setActiveCell(activeCell === index ? null : index);
      updateStatus(index,clickedname)
    };
   
    const options = {
        animationEnabled: true,
        title: {
            text: ""
        },
        axisY: {
            title: "Net Attendance (in Percentage)",
            suffix: "%"
        },
        height:380,
        data: [
            {
            type: "splineArea",
            xValueFormatString: "MMM",
            yValueFormatString: "#",
            showInLegend: true,
            color:"#9747FF",
            legendText: "Student",
            dataPoints: [
                { x: new Date(2023, 0), y: 60 }, // Use "new Date" to specify the date
                { x: new Date(2023, 1), y: 40 },
                { x: new Date(2023, 2), y: 50 },
                { x: new Date(2023, 3), y: 60 },
                { x: new Date(2023, 4), y: 70 },
                { x: new Date(2023, 5), y: 30 },
                { x: new Date(2023, 6), y: 40 },
                { x: new Date(2023, 7), y: 60 },
                { x: new Date(2023, 8), y:50 },
                { x: new Date(2023, 9), y: 55},
                { x: new Date(2023, 10), y: 35 },
                { x: new Date(2023, 11), y: 30 },
            ]
        },
            {
            type: "splineArea",
            xValueFormatString: "MMM",
            yValueFormatString: "#",
            showInLegend: true,
            legendText: "Teacher",
            color:"#FFAD00",
            dataPoints: [
                { x: new Date(2023, 0), y: 50 }, // Use "new Date" to specify the date
                { x: new Date(2023, 1), y: 65 },
                { x: new Date(2023, 2), y: 45 },
                { x: new Date(2023, 3), y: 30 },
                { x: new Date(2023, 4), y: 70 },
                { x: new Date(2023, 5), y: 60 },
                { x: new Date(2023, 6), y: 40 },
                { x: new Date(2023, 7), y: 60 },
                { x: new Date(2023, 8), y: 40},
                { x: new Date(2023, 9), y: 50},
                { x: new Date(2023, 10), y: 20 },
                { x: new Date(2023, 11), y: 10 },
            ]
        },
    ]
    }
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>HR Dashboard</h3>
                </div>
                <div className="routineentry">
                    <div className="smallheader d-flex">
                        <h4>Attendance</h4>
                    </div>
                    <div className="admbwrap pb0">
                        <Row>
                            <Col xs={12} >

                                <div className="hrbox">
                                    <div className='datetext' onClick={handleshowdatepicker}>

                                        {value.start.format("YYYY-MM-DD")}
                                        {" - "}
                                        {value.end.format("YYYY-MM-DD")}
                                        <div className="div mx-2">
                                            <BsChevronDown />

                                        </div>
                                    </div>
                                    <div className="div" style={{ background: "#fff", position: "absolute", height: "260px", zIndex: "999", right: "0px" }}>
                                        <div style={display ? { display: "block" } : { display: "none" }}>
                                            <DateRangePicker
                                                value={value}
                                                onSelect={onSelect}
                                                singleDateRange={true}
                                                className="redDate"
                                                style={{ background: "#fff" }}
                                            />
                                        </div>

                                    </div>
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                        <Row>
                                            <Col sm={3} className='m-auto'>
                                                <Nav variant="pills" className="flex justify-content-center">
                                                    <div className="navwrap d-flex">

                                                        <Nav.Item>
                                                            <Nav.Link eventKey="first">Student</Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="second">Teacher</Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="third">Employee</Nav.Link>
                                                        </Nav.Item>
                                                    </div>
                                                </Nav>
                                            </Col>
                                            <Col sm={12}>
                                                <Tab.Content style={{ marginTop: "23px" }}>
                                                    <Tab.Pane eventKey="first">
                                                        <Row>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Total Student</p>
                                                                    <h4>480</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pl5">
                                                                <div className="smvalbox">
                                                                    <p>Present</p>
                                                                    <h4>350</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Absent</p>
                                                                    <h4>80</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pl5">
                                                                <div className="smvalbox">
                                                                    <p>Late</p>
                                                                    <h4>25</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Early Leave</p>
                                                                    <h4>25</h4>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="second">
                                                        <Row>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Total Teacher</p>
                                                                    <h4>300</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pl5">
                                                                <div className="smvalbox">
                                                                    <p>Present</p>
                                                                    <h4>350</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Absent</p>
                                                                    <h4>80</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pl5">
                                                                <div className="smvalbox">
                                                                    <p>Late</p>
                                                                    <h4>25</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Early Leave</p>
                                                                    <h4>25</h4>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="third">
                                                        <Row>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Total Employee</p>
                                                                    <h4>995</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pl5">
                                                                <div className="smvalbox">
                                                                    <p>Present</p>
                                                                    <h4>350</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Absent</p>
                                                                    <h4>80</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pl5">
                                                                <div className="smvalbox">
                                                                    <p>Late</p>
                                                                    <h4>25</h4>
                                                                </div>
                                                            </Col>
                                                            <Col xs={6} lg={6} className="pr5">
                                                                <div className="smvalbox">
                                                                    <p>Early Leave</p>
                                                                    <h4>25</h4>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </div>
                            </Col>
                        </Row>
                    </div>
                            <div className="smallheader d-flex">
                                <h4>Attendance Analytics</h4>
                            </div>
                    <div className="admbwrap">
                    <Row>
                        <Col lg={7} className="pl7">
                            <div className="hrbox">
                                <div className="scrollX">
                                <div className="chartbigwidth">
                                        <CanvasJSChart options={options} />

                                </div>

                                </div>

                            </div>
                        </Col>
                    </Row>
                    </div>
                    <div className="smallheader d-flex">
                            <h4>Hiring Progress</h4>
                        </div>
                        <div className="admbwrap pr0" style={{overflowX:"scroll"}}>
                        <div className="hrbox pr0">
                            <div className="fxtdbtn">
                                <p>See All</p>
                            </div>
                            {/* <div className="billentrytoptable hronelinetablemb" > */}
                                <div className="tablewrapscroll">
                                <div className="flexvaluetable hronelinetablemb" style={{minHeight:"320px",width:"600px"}}>

                                <table>
                                    <thead>
                                        <tr>
                                            {
                                                hrDashboardHiringProcessApi.heading.map((item, key) => {
                                                    return (
                                                        <th key={key}> <div>{item.head}</div> </th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    {

                                        <tbody>
                                            {

                                                hrDashboardHiringProcessApi.data.map((item, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td>{item.fullname}</td>
                                                            <td>{item.position}</td>
                                                            <td>
                                                                {
                                                                    item.status == "Task" ?
                                                                        <PillSmall class="Task" bg="#FFF0F1" fontsize="12px" textcolor="#FF5454" text={item.status} />
                                                                        :
                                                                        item.status == "Tech Interview" ?
                                                                            <PillSmall class="TechInterview" bg="#ECF1FF" fontsize="12px" textcolor="#4976FD" text={item.status} />
                                                                            :
                                                                            item.status == "Final Interview" ?
                                                                                <PillSmall class="FinalInterview" bg="#FFEFE4" fontsize="12px" textcolor="#F89552" text={item.status} />
                                                                                :
                                                                                item.status == "Resume Review" ?
                                                                                    <PillSmall class="ResumeReview" bg="#EFFFE7" fontsize="12px" textcolor="#80B563" text={item.status} />
                                                                                    : ""
                                                                }

                                                            </td>
                                                            <td className='dotimg d-flex justify-content-start'>
                                                                <img onClick={(e)=>handleImageClick(e,key)} style={{marginTop:"9px",marginLeft:"9px"}} src={item.action} alt="" />
                                                                {activeCell === key && (
                                                                    <div className="d-block">
                                                                    <div className="drp">
                                                                        {/* Content of your dropdown */}
                                                                        <p onClick={(e)=>handleImageClick(e,key,"Task")}>Task</p>
                                                                        <p onClick={(e)=>handleImageClick(e,key,"Tech Interview")}>Tech Interview</p>
                                                                        <p onClick={(e)=>handleImageClick(e,key,"Final Interview")}>Final Interview</p>
                                                                        <p onClick={(e)=>handleImageClick(e,key,"Resume Review")}>Resume Review</p>
                                                                    </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                })

                                            }
                                        </tbody>
                                    }

                                </table>
                                </div>
                                </div>
                            {/* </div> */}
                        </div>
                        </div>
                        <div className="smallheader d-flex">
                            <h4>New Application</h4>
                        </div>
                        <div className="admbwrap pr0 pl0">

                        <div className="hrbox">
                            <div className="fxtdbtn">
                                <p>See All</p>
                            </div>
                            <div className="singleapplicantwrapper">
                            {
                                applicantList.map((item,key)=>{
                                    return(
                                        <div key={key}>
                                            <SingleApplicantBox name={item.name} img={item.img} appliedfor={item.appliedfor} phone={item.phone} mail={item.mail}/>

                                        </div>
                                    )
                                })
                            }
                            
                            </div>
                        </div>
                        </div>
                </div>
            </div>
        </div>
    </div>

    </>
  )
}

export default HRDashboardCompmb